import React from 'react';
import { faPlus, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { TimelineTaskCard } from './TimelineTaskCard';
import { useTimelineView } from './TimelineViewContext';
import { sortPlannerTasks } from './taskListOrder';

export const TimelineDayTasksModal: React.FC<{ date: Date; onClose: () => void; onPrepareAction: () => void }> = ({
    date, onClose, onPrepareAction,
}) => {
    const { t, i18n } = useTranslation();
    const { getTasksForDay, onCreateFlexibleTask } = useTimelineView();
    const tasks = sortPlannerTasks(getTasksForDay(date));
    const label = date.toLocaleDateString(i18n.language, {
        weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
    });
    return (
        <div className="timeline-day-modal-overlay" onClick={onClose} role="presentation">
            <section className="timeline-day-modal" role="dialog" aria-modal="true"
                aria-labelledby="timeline-day-modal-title" onClick={(event) => event.stopPropagation()}>
                <header>
                    <div>
                        <h2 id="timeline-day-modal-title">{label}</h2>
                        <span>{tasks.length}</span>
                    </div>
                    <button type="button" className="timeline-day-modal-close" onClick={onClose}
                        aria-label={t('dailyPlanner.cancel')}>
                        <FontAwesomeIcon icon={faXmark} />
                    </button>
                </header>
                <div className="timeline-day-modal-tasks">
                    {tasks.length ? tasks.map((task) => (
                        <TimelineTaskCard key={task.task.id} taskInfo={task} dateContext="day" onBeforeDelete={onPrepareAction}
                            onBeforeEdit={onPrepareAction} onBeforeOpen={onClose} />
                    )) : <p>{t('dailyPlanner.nothingScheduled')}</p>}
                </div>
                <button type="button" className="timeline-day-modal-add" onClick={() => {
                    onPrepareAction();
                    onClose();
                    onCreateFlexibleTask(date, 'day');
                }}>
                    <FontAwesomeIcon icon={faPlus} />
                    {t('dailyPlanner.addTask')}
                </button>
            </section>
        </div>
    );
};
